import React, { useContext } from "react";
import { Button, Col, Row, Typography, Space } from "antd";
import { COLORS } from "~constants";
import jwtDecode from "jwt-decode";
import { useNavigate, useParams } from "react-router-dom";
import { MiceReportContext } from "./context-view";

const { Paragraph, Title } = Typography;
const Index = () => {
  const token = jwtDecode(localStorage.getItem("token"));
  const userType = token?.loginAs;
  let { pageData } = useContext(MiceReportContext);
  let { date } = useParams();

  const navigate = useNavigate();
  return (
    <>
      {pageData?.length > 0 ? (
        pageData.map((data, key) => (
          <div className="row-darken">
            <Row align="top" key={key}>
              <Col span={2}>{key + 1}.</Col>
              <Col span={10}>
                <Space direction="vertical">
                  <Paragraph>Event Name:</Paragraph>
                  <Paragraph>CLient/Organizer:</Paragraph>
                  <Paragraph>No. of hours:</Paragraph>
                  <Paragraph>Types of Event: </Paragraph>
                  <Paragraph>Remarks:</Paragraph>
                  <Paragraph>Local Attendees:</Paragraph>
                  <Paragraph>Foreign Attendees:</Paragraph>
                </Space>
              </Col>
              <Col span={12}>
                <Space direction="vertical">
                  <Paragraph strong>{data.eventName}</Paragraph>
                  <Paragraph strong>{data.clientName}</Paragraph>
                  <Paragraph strong>{data.numberHrs}</Paragraph>
                  <Paragraph strong>{data.eventType}</Paragraph>
                  <Paragraph strong>{data.remarks}</Paragraph>
                  <Paragraph />
                  <Space direction="horizontal">
                    <Paragraph strong>Male: {data.phResident.male}</Paragraph>
                    <Paragraph strong>
                      Female: {data.phResident.female}
                    </Paragraph>
                  </Space>
                </Space>
              </Col>
            </Row>
            {data?.nonPhResident.length > 0 &&
              data.nonPhResident.map((records, key) => (
                <Row>
                  <Col span={4} />
                  <Col span={10}>
                    <Paragraph strong>{records.nationality}</Paragraph>
                  </Col>

                  <Col span={10}>
                    <Space direction="horizontal" size={"large"}>
                      <Paragraph strong> {records.male}</Paragraph>
                      <Paragraph strong>{records.female}</Paragraph>
                    </Space>
                  </Col>
                </Row>
              ))}
          </div>
        ))
      ) : (
        <Row className={"row-darken"} justify="center" align="center">
          <Title level={5}> Nothing to show here ...</Title>
        </Row>
      )}

      {userType !== "Administrator" && (
        <Row style={{ marginBottom: 15 }}>
          <Col span={12}>
            <Button
              htmlType="reset"
              size="large"
              style={{ backgroundColor: COLORS.green }}
              onClick={() => {
                navigate(`/v2/${userType}/mice-reports/${date}`, {
                  state: pageData,
                });
              }}
            >
              EDIT
            </Button>
          </Col>

          <Col
            span={12}
            style={{ justifyContent: "flex-end", display: "flex" }}
          >
            <Button
              size="large"
              htmlType="submit"
              style={{ backgroundColor: COLORS.orange }}
              onClick={() => {
                navigate(`/v2/${userType}/mice-reports`);
              }}
            >
              ADD REPORT
            </Button>
          </Col>
        </Row>
      )}
    </>
  );
};

export default Index;
